import PropTypes from 'prop-types';
import React, {
  useCallback,
  useEffect,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from 'styled-components';

import { VerticalTableMarquee } from '@powdr/components';
import { Components, DorLiftTrailStatus, StaticProfiles } from '@powdr/constants';
import { getLifts } from '@powdr/stores';
import { getDorStatusColorProp, getThemeValue, setStatus } from '@powdr/utils';

export const WearlynxLiftWaitTimesBoard = ({
  className = '',
  tableTitle,
  isWrapperless = false,
  enableUserScrolling = false,
  hideHeader = false,
  disableAutoScroll = false,
  disableAlternatingColors = false,
  parentColorProfile,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const useLiftsData = useSelector((state) => state.lifts);
  const { data: liftsData } = useLiftsData;
  const [marqueeData, setMarqueeData] = useState(null);

  const getWaitTimeString = useCallback((secs) => {
    if (secs < 1) {
      return 'Open';
    } if (secs < 2 * 60) {
      return '0-2';
    } if (secs < 5 * 60) {
      return '2-5';
    } if (secs < 10 * 60) {
      return '5-10';
    } if (secs < 20 * 60) {
      return '10-20';
    }
    return '20+';
  }, []);

  useEffect(() => {
    dispatch(getLifts());
  }, [dispatch]);

  useEffect(() => {
    if (liftsData && liftsData?.length > 0) {
      setMarqueeData(
        liftsData.filter((l) => l?.waitTime?.waitTimeSecs != null).map((lift) => {
          const status = setStatus(lift?.status, 'lift');

          return {
            name: lift?.name,
            placeholderText: lift?.name.charAt(0),
            icon: `status-${status?.icon}`,
            stat: getWaitTimeString(lift?.waitTime?.waitTimeSecs),
            textColorOverride: (status.id === 'opening' && lift?.waitTime?.waitTimeSecs < 1) && getThemeValue(
              theme,
              getDorStatusColorProp(DorLiftTrailStatus, lift?.status),
              Components.DOR_MEASUREMENTS,
              StaticProfiles.ALERTS,
            ),
            showIcon: status.id !== 'opening',
            boldStat: true,
          };
        }),
      );
    }
  }, [liftsData, getWaitTimeString, theme]);

  if (!marqueeData) return null;

  return (
    <VerticalTableMarquee
      className={className}
      isWrapperless={isWrapperless}
      is5050={false}
      showItemIndex={false}
      showPhotos={false}
      marqueeTitle={tableTitle}
      enableUserScrolling={enableUserScrolling}
      parentColorProfile={parentColorProfile}
      hideHeader={hideHeader}
      disableAutoScroll={disableAutoScroll}
      disableAlternatingColors={disableAlternatingColors}
      headerColorOverrides={{
        text: '#FFFFFF',
        background: '#000000',
      }}
      emptyMessage="Lift wait times currently unavailable"
      leftColumnTitle="Lift"
      rightColumnTitle="Wait Time (Min)"
      data={marqueeData}
    />
  );
};

WearlynxLiftWaitTimesBoard.propTypes = {
  className: PropTypes.string,
  tableTitle: PropTypes.string,
  parentColorProfile: PropTypes.string,
  isWrapperless: PropTypes.bool,
  enableUserScrolling: PropTypes.bool,
  hideHeader: PropTypes.bool,
  disableAutoScroll: PropTypes.bool,
  disableAlternatingColors: PropTypes.bool,
};
